module.exports = {"530326001":"古城街道","530326002":"宝云街道","530326003":"金钟街道","530326102":"娜姑镇","530326103":"迤车镇","530326104":"乐业镇","530326105":"矿山镇","530326106":"者海镇","530326107":"大井镇","530326108":"待补镇","530326201":"大海乡","530326202":"老厂乡","530326203":"五星乡","530326204":"大桥乡","530326205":"纸厂乡","530326206":"马路乡","530326207":"火红乡","530326208":"新街回族乡","530326209":"雨碌乡","530326210":"鲁纳乡","530326211":"上村乡","530326212":"驾车乡","530326213":"田坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530326.json
// module id = 2561
// module chunks = 0